const euroFormatter = new Intl.NumberFormat('en-IE', {
  style: 'currency',
  currency: 'EUR',
});

export const formatToEuro = (nonEuroValue: number) => euroFormatter.format(nonEuroValue);
